import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/layout/AccountModeBadge.tsx
// Persistent badge shown in the TopBar for education-mode accounts.
// Fetches /profile/me once and caches the account_mode in component state.
import { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
export function AccountModeBadge() {
    const [mode, setMode] = useState(null);
    useEffect(() => {
        let cancelled = false;
        api
            .me()
            .then((p) => {
            if (!cancelled)
                setMode(p.account_mode ?? "real");
        })
            .catch(() => {
            if (!cancelled)
                setMode(null);
        });
        return () => {
            cancelled = true;
        };
    }, []);
    if (mode !== "education")
        return null;
    return (_jsxs("span", { className: "inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-[10px] font-semibold tracking-widest text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 uppercase", title: "Demo account \u2014 analyses run against a hypothetical profile, not real data.", children: [_jsx("span", { className: "w-1.5 h-1.5 rounded-full bg-emerald-400" }), "Demo"] }));
}
